import React from 'react'
import Lottie from 'react-lottie';
import './Downarrow.css'
import * as animationData from './Animation - 1747295476198.json';

const DownArrow = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };


    const handleScrollDown = () => {
        const scrollAmount = window.innerHeight * 0.5; // 10% of the viewport height
        window.scrollBy({ top: scrollAmount, behavior: 'smooth' });
    };

    return (
        <>
            <section className='scrollbtndiv'>
                <div className='down-btn' onClick={handleScrollDown}>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                        height={40}
                        width={40}
                    />
                </div>
            </section>
        </>
    )
}

export default DownArrow